// ===================================================================
// KAIXO - AreaUnlockModal
// ===================================================================
// Modal que aparece cuando un admin (no general) intenta entrar a
// una pestaña de área y no tiene token activo. Pide la contraseña
// específica de esa área.
// ===================================================================

import React, { useState } from 'react';
import { Icons } from '../Icons/Icons';
import './AreaUnlockModal.css';

const AREA_LABELS = {
    support:      'Soporte',
    verification: 'Verificaciones',
    accounting:   'Contabilidad',
    maintenance:  'Mantenimiento'
};

export default function AreaUnlockModal({ area, onUnlock, onCancel, loading, error, attemptsLeft, lockedUntil }) {
    const [password, setPassword] = useState('');

    const submit = (e) => {
        e?.preventDefault();
        if (!password) return;
        onUnlock(password);
    };

    const isLocked = lockedUntil && new Date(lockedUntil) > new Date();

    return (
        <div className="area-unlock-overlay">
            <form className="area-unlock-modal" onSubmit={submit}>
                <div className="area-unlock-icon">🔒</div>
                <h2>Acceso a {AREA_LABELS[area] || area}</h2>
                <p className="area-unlock-sub">
                    Esta área requiere una contraseña independiente. La sesión durará 30 minutos.
                </p>

                <input
                    type="password"
                    placeholder="Contraseña de área"
                    autoFocus
                    autoComplete="new-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    disabled={loading || isLocked}
                />

                {error && (
                    <div className="area-unlock-error">
                        {error}
                        {typeof attemptsLeft === 'number' && attemptsLeft > 0 && (
                            <div className="area-unlock-meta">Intentos restantes: {attemptsLeft}</div>
                        )}
                    </div>
                )}

                {isLocked && (
                    <div className="area-unlock-locked">
                        Bloqueada hasta {new Date(lockedUntil).toLocaleTimeString()}
                    </div>
                )}

                <div className="area-unlock-actions">
                    <button type="button" className="area-unlock-btn-cancel" onClick={onCancel}>
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        className="area-unlock-btn-primary"
                        disabled={loading || isLocked || !password}
                    >
                        {loading ? 'Verificando…' : 'Desbloquear'}
                    </button>
                </div>
            </form>
        </div>
    );
}
